import { Directive } from '@angular/core';

@Directive({
  selector: '[phx-list-post]',
  host: { class: 'phx-list-post' },
})
export class PhxListItemPostDirective { }
